import { render, staticRenderFns } from "./QsInfo.vue?vue&type=template&id=e04aaade&scoped=true&"
import script from "./QsInfo.vue?vue&type=script&lang=js&"
export * from "./QsInfo.vue?vue&type=script&lang=js&"
import style0 from "./QsInfo.vue?vue&type=style&index=0&id=e04aaade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04aaade",
  null
  
)

export default component.exports